import axios from 'axios';

const APP_KEY = 'e2e653a7994e438b88179c16482b09cb'; 
const LOGIN_TYPE = 2;

export async function uploadFileToPicJd(base64StrInput) {
    let base64ForFetch;
    let fileType = 'image/png';

    if (base64StrInput.startsWith('data:image/jpeg;base64,')) {
        fileType = 'image/jpeg';
        base64ForFetch = base64StrInput;
    } else if (base64StrInput.startsWith('data:image/png;base64,')) {
        fileType = 'image/png';
        base64ForFetch = base64StrInput;
    } else {
        fileType = 'image/png';
        base64ForFetch = `data:${fileType};base64,${base64StrInput}`;
    }
    
    const base64Response = await fetch(base64ForFetch);
    const blob = await base64Response.blob();
   
    const extension = fileType.split('/')[1] || 'png';
    const fileName = Date.now() + '.' + extension; 
    const file = new File([blob], fileName, { type: fileType });

   
    const url = `https://pic.jd.com/${LOGIN_TYPE}/${APP_KEY}`;
    const formData = new FormData();
    formData.append('file', file, fileName);

    try {
        const response = await axios.post(url, formData, {
            withCredentials: true
        });
        if (response && response.data && response.data.id === '1' && response.data.msg) {
            return response.data.msg;
        } else {
            throw response.data;
        }
    } catch (error) {
        throw error;
    }
}
